export type GalleryPhoto = {
  src: string;
  alt: string;
  caption: string;
};

export const crewPhoto = {
  src: 'https://cdn.magicpatterns.com/uploads/kpaoL6rMYTja21r7ZEKg94/dany2.png',
  alt: 'Dany Landscaping crew setting white limestone borders around a front yard flower bed',
};

export const workVideos = [
  {
    label: 'Crew at work',
    title: 'See our crew at work',
    body: 'Same team, every job. Here’s a look at how we work on a real project.',
    src: 'https://cdn.magicpatterns.com/uploads/wRWwLk3MqK9R2jCb2dNP5F/a36c7e7d-810f-4f14-a46b-fabb33d51b46.mov',
    poster: 'https://cdn.magicpatterns.com/uploads/kpaoL6rMYTja21r7ZEKg94/dany2.png',
  },
  {
    label: 'Finished project',
    title: 'A complete project, start to finish',
    body: 'Walk through a finished job and see the final result up close.',
    src: 'https://cdn.magicpatterns.com/uploads/a4VR7AqPGVxKaDeEhFc9VS/721935e6-c3b5-4a95-b413-efbbc25ebd63.mov',
    poster: 'https://cdn.magicpatterns.com/uploads/cdFHLGKTP5hyr8Fcm2xfgD/dany5.png',
  },
  {
    label: 'Fence job',
    title: 'A new cedar fence, done right',
    body: 'Straight lines, solid posts, and a clean finish that lasts.',
    src: 'https://cdn.magicpatterns.com/uploads/2t7devNFgGVdAYMzuPzK1r/61717934-6bf0-461f-976b-726f28119948.MP4',
    poster: 'https://cdn.magicpatterns.com/uploads/7TMn5YeWe1ENNtLhWQ99Bo/dany4.png',
    muted: true,
  },
];

export const beforeAfterProjects = [
  {
    label: 'Stone walkway',
    title: 'From bare dirt to a stone walkway',
    body: 'Dead grass cleared, path laid out, and a stepping-stone walkway with black river rock and steel edging — plus a fresh lawn on both sides.',
    before: {
      src: 'https://cdn.magicpatterns.com/uploads/gZR67Fmw8w4ePT2esmi4rM/dany15.png',
      alt: 'Before: dry brown lawn with a strip of bare dirt marked out with string',
    },
    after: {
      src: 'https://cdn.magicpatterns.com/uploads/wXqrt9QmghEHEuG75787Kv/dany16.png',
      alt: 'After: green lawn with a stepping-stone walkway in black river rock leading to a white brick home',
    },
  },
  {
    label: 'Fire pit patio',
    title: 'A backyard fire pit patio, built from scratch',
    body: 'Curved stone walls, a built-in fire pit, gravel and flagstone pavers, and fresh planting beds around the edge.',
    before: {
      src: 'https://cdn.magicpatterns.com/uploads/9bmGb18mibs2iNpJq7vt3t/dany18.png',
      alt: 'Before: crew building curved stone walls and a fire pit ring on a sand base',
    },
    after: {
      src: 'https://cdn.magicpatterns.com/uploads/bSf6JpxzLWsXLBDqKACiaC/dany19.png',
      alt: 'After: finished gravel patio with a stone fire pit, flagstone pavers, and planted beds',
    },
  },
];

export const galleryPhotos: GalleryPhoto[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/cdFHLGKTP5hyr8Fcm2xfgD/dany5.png',
    alt: 'Finished front yard with curved stone flower beds and green lawn at sunset',
    caption: 'Stone beds & fresh lawn',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mAwSnqFJ7tvCJTWCFon5Qt/dany8.png',
    alt: 'Two trees framed by gray stone tree rings and a matching flower bed wall in front of a brick home',
    caption: 'Stone tree rings',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8gUSh2wQgRS668hZU1yio4/dany9.png',
    alt: 'Modern farmhouse with fresh black mulch bed, metal edging, and new plants along the walkway',
    caption: 'Mulch & planting',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/98MWkK2BL7kMcPoKuLnUNy/dany6.png',
    alt: 'Crew member laying stone border pieces around trees in a front yard',
    caption: 'On the job: stone borders',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/p1NF9W81fdvs2JUCSoQBBJ/dany7.png',
    alt: 'Crew member clearing a flower bed with bagged debris ready for haul-off',
    caption: 'On the job: bed cleanup',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cpaUdU6DBBLFXUr6uZN6Z1/dany13.png',
    alt: 'Crew member planting new shrubs along a front flower bed next to a young tree',
    caption: 'On the job: new shrubs',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4M63eoY6n5xkcWFitZs4sV/dany14.png',
    alt: 'Crew member installing brick edging around a red mulch flower bed',
    caption: 'On the job: edging & mulch',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nmRiocFZ8hLgkHtWFgePH5/dany17.png',
    alt: 'Circular raised stone garden bed with a flagstone path and potted roses ready to plant',
    caption: 'Stone rose garden',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/t5qMxq3ZLXLZ8AdMg8ZYbE/dany20.png',
    alt: 'Crew member hand-finishing a freshly poured concrete driveway in front of a new home',
    caption: 'On the job: new driveway',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/f9srUTPJ3xrWSBWL7QiP8E/dany21.png',
    alt: 'Long sandstone retaining wall along a cedar fence with fresh green lawn',
    caption: 'Stone wall & cedar fence',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pNGrLHpu1oZyxv3HSJYxej/dany22.png',
    alt: 'New concrete slab poured in a backyard beside a cedar fence',
    caption: 'Backyard concrete slab',
  },
];
